import type { RouteRecordRaw } from "vue-router";

export const TenantsRoutes: RouteRecordRaw[] = [
    {
        path: '',
        name: 'tenantsList',
        component: () => import('./components/TenantsList.vue')
    },
    {
        path: ':id',
        name: 'tenantsView',
        component: () => import('./components/TenantView/Index.vue'),
        children: [
            {
                path: '',
                name: 'tenantsViewOverview',
                component: () => import('./components/TenantView/Overview.vue')
            },
            {
                path: 'users',
                name: 'tenantsViewUsers',
                component: () => import('./components/TenantView/Users.vue')
            },
            {
                path: 'modules',
                name: 'tenantsViewModules',
                component: () => import('./components/TenantView/Modules.vue')
            },
            {
                path: 'settings',
                name: 'tenantsViewSettings',
                component: () => import('./components/TenantView/Settings.vue'),
                redirect: { name: 'tenantsViewSettingsGeneral' },
                children: [
                    {
                        path: '',
                        name: 'tenantsViewSettingsGeneral',
                        component: () => import('../components/General.vue')
                    },
                    {
                        path: 'api',
                        name: 'tenantsViewSettingsApi',
                        component: () => import('../components/Api.vue')
                    },
                    {
                        path: 'portal',
                        name: 'tenantsViewSettingsPortal',
                        component: () => import('../components/portal/Index.vue')
                    },
                    {
                        path: 'whatsapp',
                        name: 'tenantsViewSettingsWhatsapp',
                        component: () => import('../components/WhatsApp.vue')
                    },
                    {
                        path: 'theme',
                        name: 'tenantsViewSettingsTheme',
                        component: () => import('../components/Theme.vue')
                    }
                ]
            }
        ]
    }
]
